import { useMemo } from "react";
import { CroppingPatternReportModel } from "@agroyaar/sdk";
import LineChart from "@/shared/components/charts/LineChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";

interface AnnuallyPerformancePotentialProps {
  croppingPatternReports: CroppingPatternReportModel[];
  chartYears: string[];
}

const AnnuallyPerformancePotential = ({
  croppingPatternReports,
  chartYears,
}: AnnuallyPerformancePotentialProps) => {
  const series = useMemo(
    () =>
      croppingPatternReports.map(({ annuallyPerformancePotential, crop }) => ({
        name: crop.persianName,
        data: annuallyPerformancePotential.map(({ value }) => value),
      })),
    [croppingPatternReports]
  );

  return (
    <ReportTemplate serviceType="CROPPING_PATTERN" pageNumber={4}>
      <div className="w-full flex flex-col gap-6">
        <Title>پتانسیل عملکرد 30 سال گذشته</Title>
        <div className="w-full flex flex-col justify-center items-center gap-3 my-8">
          <LineChart
            yAxisTitle="پتانسیل عملکرد (تن در هکتار)"
            xAxisLabelsOptionsStep={1}
            labelsFontSize="10px"
            categories={chartYears}
            series={series}
          />
          <Title>مقدار پتانسیل عملکرد برآورد شده در 30 سال گذشته</Title>
        </div>
      </div>

      <NoteBox>
        با توجه به شرایط اقلیمی منطقه، پتانسیل عملکرد محصولات برآورد شده است.
        پتانسیل عملکرد به معنای بالاترین میزان عملکردی است که با مدیریت بهینه
        تمامی عوامل موثر بر عملکرد (مانند آبیاری، تغذیه گیاهی و...) می‌توان به
        آن دست یافت. بنابراین، در نظر داشته باشید که مقدار واقعی عملکرد با توجه
        به شرایط خاک و شرایط مدیریتی کمتر از این مقدار خواهد بود و با بهبود
        مدیریت مزرعه میتوان به پتانسیل عملکرد نزدیک شد.
      </NoteBox>
    </ReportTemplate>
  );
};

export default AnnuallyPerformancePotential;
